var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1999 9.68555C19.4672 10.6324 20.5999 13.0165 20.5999 14.4855C20.5999 14.9431 20.266 15.3141 19.8541 15.3141H19.3999M14.5999 5.80432C15.4197 5.33006 15.9713 4.44365 15.9713 3.4284C15.9713 2.41316 15.4197 1.52675 14.5999 1.05249M2.14567 15.3141H15.2827C15.6946 15.3141 16.0285 14.9431 16.0285 14.4855C16.0285 11.6089 13.6252 9.27693 8.71419 9.27693C3.80317 9.27693 1.3999 11.6089 1.3999 14.4855C1.3999 14.9431 1.7338 15.3141 2.14567 15.3141ZM11.457 3.4284C11.457 4.94324 10.229 6.17126 8.71419 6.17126C7.19935 6.17126 5.97133 4.94324 5.97133 3.4284C5.97133 1.91357 7.19935 0.685547 8.71419 0.685547C10.229 0.685547 11.457 1.91357 11.457 3.4284Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAva);
export default __webpack_public_path__ + "static/media/ava.7d001b91c365c6ceca1ec502bdb79266.svg";
export { ForwardRef as ReactComponent };